<template>
  <component
    :is="isOrderedList ? 'ol' : 'ul'"
    class="text-base"
    :class="{ 'pl-4': !isOrderedList }"
  >
    <li :class="{ 'list-disc': !isOrderedList }">
      {{ isOrderedList ? `${numeration}. ${content}` : content }}
    </li>
    <li
      v-for="(item, idx) in items"
      :key="item.content"
      class="ml-4"
      :class="{ 'list-disc': !isOrderedList }"
    >
      {{
        isOrderedList
          ? `${numeration}.${idx + 1}. ${item.content}`
          : item.content
      }}
      <template v-if="item.items">
        <ListBlock
          v-for="(child, childIdx) in item.items"
          :key="child.content"
          :list-style="listStyle"
          :content="child.content"
          :items="child.items"
          :numeration="`${numeration}.${idx + 1}.${childIdx + 1}`"
          class="ml-4"
        />
      </template>
    </li>
  </component>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  export type ListProps = {
    listStyle?: string;
    numeration?: string;
    content?: string;
    items: Array<ListProps>;
  };

  const props = defineProps<ListProps>();
  const isOrderedList = computed(() => props.listStyle === 'ordered');
</script>
